<template>
    <v-dialog v-model="dialog" width="600">
        <v-card shaped>
            <v-card-title class="primary white--text">
                <h3>Comercializadora</h3>
            </v-card-title>
            <v-card-text class="pa-3">
                <v-container fluid>
                    <ComercializadoraForm :loading="loading" v-model="comercializadoraData" :default="defaultComercializadoraData" :valid.sync="isComercializadoraDataValid"/>
                    <v-checkbox v-model="hasUser" label="¿posee usuario?" :disabled="!!(comercializadora && comercializadora.user)"></v-checkbox>
                    <v-card outlined tile v-if="hasUser">
                        <v-card-title>Usuario</v-card-title>
                        <v-card-text>
                            <UserForm :loading="loading" v-model="userData"  :default="defaultUserData" :valid.sync="isUserDataValid"/>
                        </v-card-text>
                    </v-card>
                </v-container>
            </v-card-text>
            <v-divider/>
            <v-card-actions>
                <v-spacer/>
                <v-btn color="primary" text :disabled="loading" @click="reset()">RESETEAR</v-btn>
                <v-btn color="primary" :disabled="!isValid || loading" :loading="loading" @click="submit()">
                    <v-icon>mdi-content-save</v-icon>
                    <span v-if="this.comercializadora">Editar comercializadora</span>
                    <span v-else>Añadir comercializadora</span>
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>
<script>
import ComercializadoraForm from "./form"
import UserForm from '@components/entities/general/user/form';

import ComercializadoraService from '@services/comercio/ComercializadoraService';

export default {
    components: {
        ComercializadoraForm,
        UserForm
    },
    props: ['comercializadora', 'open'],
    data: () => ({
        loading: false,
        dialog: false,

        context: 'new',

        comercializadoraData: {},
        defaultComercializadoraData: null,
        isComercializadoraDataValid: false,

        userData: {},
        defaultUserData: null,
        isUserDataValid: false,

        hasUser: false,
    }),
    mounted: function () {
        this.reset();
    },
    computed: {
        isValid: function () {
            let isComercializadoraDataValid = this.isComercializadoraDataValid;
            let isUserDataValid = false;
            if (this.hasUser) {
                isUserDataValid = this.isUserDataValid;
            } else {
                isUserDataValid = isComercializadoraDataValid;
            }
            return this.comercializadora ? isComercializadoraDataValid || isUserDataValid : isComercializadoraDataValid && isUserDataValid;
        }
    },
    methods: {
        close: function () {
            this.$emit('update:open', false);
        },
        submit: function () {
            this.loading = true;
            let action = null;
            const data = {};

            if (this.isComercializadoraDataValid && Object.keys(this.comercializadoraData).length) data['comercializadora'] = this.comercializadoraData;
            if (this.hasUser && this.isUserDataValid && Object.keys(this.userData).length) data['user'] = this.userData;

            if (this.comercializadora) action = ComercializadoraService.update(this.comercializadora.id, data);
            else action = ComercializadoraService.create(data);

            action
                .then(({ comercializadora }) => {
                    this.$ui.notificate({message: 'Comercializadora guardada'});
                    this.emit(comercializadora);
                    this.close();
                })
                .catch(() => this.$ui.notificate({message: 'Error guardando la comercializadora', color: 'error'}))
                .finally(() => this.loading = false);
        },
        emit: function (data) {
            this.$emit('saved', data);
        },
        reset: function () {
            if (this.comercializadora) {
                this.context = 'edit';
                this.defaultComercializadoraData = { ... this.comercializadora};
                if (this.comercializadora.user) {
                    this.hasUser = true;
                    this.defaultUserData = { ... this.comercializadora.user };
                } else {
                    this.hasUser = false;
                    this.defaultUserData = null;
                }
            } else {
                this.context = 'new';
                this.defaultComercializadoraData = null;
                this.defaultUserData = null;
            }
            this.comercializadoraData = {};
            this.userData = {};
        }
    },
    watch: {
        open: function (open) {
            this.reset();
            this.dialog = open;
        },
        dialog: function (dialog) {
            if (!dialog) {
                this.$emit('update:open', false);
                this.reset();
            }
        },
    }
}
</script>
